import type { ReadFileResult } from './types.js';
import { guessMimeType } from './guess-mime-type.js';
import { readFileBufferFullAsync } from './read-file-buffer-full-async.js';

export async function readFileBinaryFullAsync(filePath: string): Promise<ReadFileResult & { mimeType: string }> {
  const { buffer, size } = await readFileBufferFullAsync(filePath);
  return {
    content: buffer.toString('base64'),
    size,
    mimeType: guessMimeType(filePath),
  };
}
